import { render } from "./customedit.vue?vue&type=template&id=d355e47a"
import script from "./customedit.vue?vue&type=script&lang=js"
export * from "./customedit.vue?vue&type=script&lang=js"

import "./customedit.vue?vue&type=style&index=0&id=d355e47a&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__